export const GlobalVariables = Object.freeze({
  Table_Action_Menu_Buttons_Tooltip_Message: $localize`To enable, please select one or more record on the table.`,
  Bulk_Delete_Dialogue_Message: $localize`Are you sure you want to delete the selected records?`,
  Bulk_Disable_Dialogue_Message: $localize`Are you sure you want to disable the selected records?`,
  Save_Button_Tooltip_Message: $localize`Save`,
  Edit_Button_Tooltip_Message: $localize`Edit`,
  Delete_Button_Tooltip_Message: $localize`Delete`,
  Revert_Button_Tooltip_Message: $localize`Revert`,
  offboard_button_tooltip_message: $localize`Offboard`,
  Clear_filters_button__Tooltip_Message: $localize`Clear Filters`,
  Bulk_Operations_button_Tooltip_Message: $localize`Bulk Operations`,
  Import_Export_Tooltip_Message: $localize`Import/Export`,
  Close_Button_Tooltip_Message: $localize`Close`,
  Select_Language_Tooltip_Message: $localize`Select Language`,
  Profile_Menu_Tooltip_Messaage: $localize`Profile Menu`,
  Allow_All: $localize`Allow All`,
  Disabled_All: $localize`Disabled`,
  Some_Allowed_Some_Disabled: $localize`Some allowed, some disabled`,
  CONFIRMED: $localize`CONFIRMED`,
  CANCELLED: $localize`CANCELLED`,
  ResourceURL: {
    //url: scope name (resource)
    dashboard: 'dashboard',
    clients: 'clients',
    'data-sources': 'data-sources',
    'data-internal-use': 'data-internal-use',
    'product-purchased': 'product-purchased',
    chargebacks: 'chargebacks',
    merchants: 'merchants',
    'merchant-services': 'merchant-services',
    requests: 'requests',
    descriptors: 'descriptors',
    'billing-client-service': 'billing-client-services',

    login: 'login',
    'user-profile': 'profile',
    settings: 'settings',
    'alerts-action-queue': 'alerts-action-queues',
    'client-trx-data': 'client-trx-data',
    alerts: 'queue-alerts',
    summary: 'summary',
    'merchant-data-sources': 'merchant-data-sources',
    'titan-source': 'titan-source',
    'titan-runner': 'titan-runner',
    'titan-process': 'titan-process',
    'titan-runner-audit': 'titan-runner-audit',
    'titan-action': 'titan-action',
    'titan-rac-config': 'titan-rac-config',
    'users': 'users',
    'notifications-services': 'notifications-services',
    'user-class': 'user-class',
    'merchant-groups': 'merchant-groups',
    'bins': 'tools',
    'mcc': 'tools',
    'fdid-warnings': 'fdid-warnings',
    'sessions': 'fdid-sessions',
    'graphs': 'fdid-graphs',
    'profile': 'fdid-graphs',
    'fdid-warnings-settings': 'fdid-warnings-settings',
    'titan-onboarding': 'titan-onboarding',
    'client-onboarding': 'client-onboarding',
    'edit-client': 'clients',
    'mids-management': 'mids-management',
    'fdid-onboarding': 'fdid-onboarding',
    'create-new-merchant': 'create-new-merchant',
    'decision': 'mids-management',
    'single-merchant': 'mids-management',
  },

  onboardingURL: ['titan-onboarding', 'fdid-onboarding'],


  quicksightURL: ['/alerts', '/partner-dashboard', '/dashboard', '/savings-calculator'],

  ActionsURL: {
    'create-user': { resource: 'users', actions: 'create' },
  },
  titanUrl: [
    '/titan-source',
    '/titan-runner-audit',
    '/titan-rac-config',
    '/titan-runner',
    '/titan-process',
    '/titan-action',
  ],
  tableURL: [
    '/clients',
    '/data-sources',
    '/data-internal-use',
    '/product-purchased',
    '/chargebacks',
    '/merchants',
    '/merchant-services',
    '/requests',
    '/descriptors',
    '/billing-client-service',
    '/alerts-action-queue',
    '/client-trx-data',
    '/summary',
    '/merchant-data-sources',
  ],
  adminURL: ['/users',
    '/user-class',
    '/merchant-groups',
    '/client',
    '/decision',
    '/single-merchant'
  ],
  queueURL: ['/alerts'],
  toolsURL: ['/mcc', '/bins'],
  fdIdURL: ['/fdid-warnings', '/sessions', '/graphs', '/profile', '/warnings-settings'],
  BulkUpdateModalHeight: 'calc(100vh - 80px)',
  BulkUpdateModalMaxWidth: '1440px',
  BulkUpdateModalWidth: 'calc(100vw - 80px)',
  BulkDeleteModalHeight: '400px',
  BulkDeleteModalWidth: '300px',
  PaginationSizes: [25, 100, 999999],

  outcomeOption: {
    Open: [
      {
        value: 'resolved',
        text: $localize`Refunded or Resolved with Card Holder`,
      },
      {
        value: 'previously_refunded',
        text: $localize`Previous Refunded`,
      },
      {
        value: 'previous_chargeback',
        text: $localize`Previous Chargeback`,
      },
      {
        value: 'unresolved_dispute',
        text: $localize`Allow to become a Chargeback so I can Represent`,
      },
      {
        value: 'notfound',
        text: $localize`Not Found`,
      },
      {
        value: 'other',
        text: $localize`Other`,
      },
    ],
    Completed: [
      {
        value: 'stopped',
        text: $localize`Stopped`,
      },
      {
        value: 'partially_stopped',
        text: $localize`Partially Stopped`,
      },
      {
        value: 'previously_cancelled',
        text: $localize`Previously Cancelled`,
      },
      {
        value: 'previous_chargeback',
        text: $localize`Previous Chargeback`,
      },
      {
        value: 'missed',
        text: $localize`Missed`,
      },
      {
        value: 'notfound',
        text: $localize`Not Found`,
      },
      {
        value: 'account_suspended',
        text: $localize`Account Suspended`,
      },
      {
        value: 'other',
        text: $localize`Other`,
      },
    ],
  },
  RefundedOption: [
    {
      value: 'refunded',
      text: $localize`Refunded`,
    },
    {
      value: 'not_refunded',
      text: $localize`Not Refunded`,
    },
    {
      value: 'not_settled',
      text: $localize`Not Settled`,
    },
  ],
  CreditStatusOption: [
    {
      value: 3,
      text: $localize`Approved`,
    },
    {
      value: 2,
      text: $localize`Submitted to Vendor`,
    },
    {
      value: 1,
      text: $localize`Received Credit Request`,
    },
    {
      value: -1,
      text: $localize`Denied`,
    },
  ],

  menu: [
    {
      name: `Dashboard`,
      url: 'quicksight/dashboard',
      icon: 'dashboard',
      scope: 'dashboard',
      subMenu: [],
    },
    {
      name: $localize`Partner Dashboard`,
      url: 'quicksight/partner-dashboard',
      subMenu: [],
      icon: 'analytics',
      scope: 'quicksight',
    },
    {
      name: $localize`Savings Calculator`,
      url: 'quicksight/savings-calculator',
      subMenu: [],
      icon: 'calculate',
      scope: 'savings-calculator',
    },
    {
      name: $localize`Queue`,
      url: '/queue',
      icon: 'toc',
      subMenu: [
        {
          name: $localize`Alerts`,
          url: 'queue/alerts',
          icon: 'splitscreen',
          scope: 'alerts',
          subMenu: [],
        },
      ],
    },
    {
      name: $localize`Admin`,
      url: '/admin',
      icon: 'admin_panel_settings',
      subMenu: [
        {
          name: $localize`Users`,
          url: 'admin/users',
          subMenu: [],
          icon: 'group',
          scope: 'users',
        },
        {
          name: $localize`User Class`,
          url: 'admin/user-class',
          subMenu: [],
          icon: 'badge',
          scope: 'user-class',
        },
        {
          name: $localize`Client`,
          url: 'admin/client',
          subMenu: [],
          icon: 'contacts_product',
          scope: 'notifications-services',
        },
        {
          name: $localize`MIDs Management`,
          url: 'admin/mids-management',
          subMenu: [],
          icon: 'store',
          scope: 'mids-management',
        },
        {
          name: $localize`Merchant Groups`,
          url: 'admin/merchant-groups',
          subMenu: [],
          icon: 'storefront',
          scope: 'merchant-groups',
        },
        {
          name: $localize`Merchant Management`,
          url: 'admin/decision',
          subMenu: [],
          icon: 'storefront',
          scope: 'mids-management',
        },
      ],
    },
    {
      name: $localize`Tables`,
      url: '/tables',
      icon: 'table_chart',
      subMenu: [
        {
          name: $localize`Clients`,
          url: 'tables/clients',
          subMenu: [],
          icon: 'table',
          scope: 'clients',
        },
        {
          name: $localize`Data Sources`,
          url: 'tables/data-sources',
          subMenu: [],
          icon: 'table',
          scope: 'data-sources',
        },
        {
          name: $localize`Data Internal Use`,
          url: 'tables/data-internal-use',
          subMenu: [],
          icon: 'table',
          scope: 'data-internal-use',
        },
        {
          name: $localize`Product Purchased`,
          url: 'tables/product-purchased',
          subMenu: [],
          icon: 'table',
          scope: 'data-internal-use',
        },
        {
          name: $localize`Chargebacks`,
          url: 'tables/chargebacks',
          subMenu: [],
          icon: 'table',
          scope: 'chargebacks',
        },
        {
          name: $localize`Merchants`,
          url: 'tables/merchants',
          subMenu: [],
          icon: 'table',
          scope: 'merchants',
        },
        {
          name: $localize`Merchant Services`,
          url: 'tables/merchant-services',
          subMenu: [],
          icon: 'table',
          scope: 'merchant-services',
        },
        {
          name: $localize`Requests`,
          url: 'tables/requests',
          subMenu: [],
          icon: 'table',
          scope: 'requests',
        },
        {
          name: $localize`Descriptors`,
          url: 'tables/descriptors',
          subMenu: [],
          icon: 'table',
          scope: 'descriptors',
        },
        {
          name: $localize`Billing Client Service`,
          url: 'tables/billing-client-service',
          subMenu: [],
          icon: 'table',
          scope: 'billing-client-service',
        },
        {
          name: $localize`Alerts Action Queue`,
          url: 'tables/alerts-action-queue',
          subMenu: [],
          icon: 'table',
          scope: 'alerts-action-queue',
        },
        {
          name: $localize`Client Trx Data`,
          url: 'tables/client-trx-data',
          subMenu: [],
          icon: 'table',
          scope: 'client-trx-data',
        },
        {
          name: $localize`Summary`,
          url: 'tables/summary',
          subMenu: [],
          icon: 'table',
          scope: 'summary',
        },
        {
          name: $localize`Merchant Data Sources`,
          url: 'tables/merchant-data-sources',
          subMenu: [],
          icon: 'table',
          scope: 'merchant-data-sources',
        },
      ],
    },
    {
      name: 'Titan',
      url: '/titan',
      icon: 'smart_toy',
      subMenu: [
        {
          name: $localize`RAC Config`,
          url: 'titan/titan-rac-config',
          subMenu: [],
          icon: 'table',
          scope: 'titan-rac-config',
        },
        {
          name: $localize`Runner Audit`,
          url: 'titan/titan-runner-audit',
          subMenu: [],
          icon: 'table',
          scope: 'titan-runner-audit',
        },
        {
          name: $localize`Runner Types`,
          url: 'titan/titan-runner',
          subMenu: [],
          icon: 'table',
          scope: 'titan-runner',
        },
        {
          name: $localize`Process Types`,
          url: 'titan/titan-process',
          subMenu: [],
          icon: 'table',
          scope: 'titan-process',
        },
        {
          name: $localize`Action Types`,
          url: 'titan/titan-action',
          subMenu: [],
          icon: 'table',
          scope: 'titan-action',
        },
        {
          name: $localize`Source Types`,
          url: 'titan/titan-source',
          subMenu: [],
          icon: 'table',
          scope: 'titan-source',
        },
      ]
    },
    {
      name: $localize`Tools`,
      url: '/tools',
      icon: 'home_repair_service',
      scope: 'tools',
      subMenu: [
        {
          name: $localize`BINS`,
          url: 'tools/bins',
          subMenu: [],
          icon: 'credit_card',
          scope: 'tools',
        },
        {
          name: $localize`MCC`,
          url: 'tools/mcc',
          subMenu: [],
          icon: 'category',
          scope: 'tools',
        },
      ],
    },
    {
      name: $localize`FD.ID`,
      url: '/fdid',
      icon: 'fingerprint',
      subMenu: [
        {
          name: $localize`Graphs`,
          url: 'fdid/graphs',
          subMenu: [],
          icon: 'dashboard',
          scope: 'fdid-graphs',
        },
        {
          name: $localize`Sessions`,
          url: 'fdid/sessions',
          subMenu: [],
          icon: 'tv_signin',
          scope: 'fdid-sessions',
        },
        {
          name: $localize`Warnings`,
          url: 'fdid/fdid-warnings',
          subMenu: [],
          icon: 'policy_alert',
          scope: 'fdid-warnings',
        },
        {
          name: $localize`Warnings Settings`,
          url: 'fdid/fdid-warnings-settings',
          subMenu: [],
          icon: 'settings',
          scope: 'fdid-warnings-settings',
        },],
    },
    {
      name: $localize`Onboarding`,
      url: '/onboarding',
      icon: 'power_settings_circle',
      scope: 'titan-onboarding',
      subMenu: [
        {
          name: $localize`Titan`,
          url: 'onboarding/titan-onboarding',
          subMenu: [],
          icon: 'smart_toy',
          scope: 'titan-onboarding',
        },
        {
          name: $localize`FD.ID`,
          url: 'onboarding/fdid-onboarding',
          subMenu: [],
          icon: 'fingerprint',
          scope: 'fdid-onboarding',
        },
      ],
    },


  ],
  DatePropList: [
    'activityDate',
    'createdDate',
    'lastUpdated',
    'datePosted',
    'transaction_date',
    'representmentDate',
    'fdCreateDateTime',
    'lastUpdated',
    'receiptOrderDate',
    'receiptDownloadDateTime',
    'createdAt',
    'updatedAt',
    'created_at',
    'updated_at',
    'dateEnabledYMD',
    'created_At',
    'updated_At',
    'disputeInitiatedDate',
    'cardExpirationDate',
    'networkTimestamp',
    'fraudReportDate',
    'fraudReportLastUpdateDate',
    'dateFraudeReportedToIssuer',
    'chargebackDate',
    'fdDateTime',
    'expiresAt',
    'usedAt',
    'archivedAt',
    'requestDateTime',
    'trxDate',
    'created_at',
    'updated_at',
    'started_at',
    'stopped_at',
    'date_range_from',
    'date_range_to',
  ],
  DropdownPropList: ['source_type_id', 'runner_id'],
  CustomValidationInputList: ['ip_address'],
  snackBarDuration: 5000,
  maxRecordsForDropdown: 99999,
  DefaultTimeFrom: '00:59',
  DefaultTimeTo: '11:59',
  urlSegmentList_to_localize: {
    tables: $localize`tables`,
    'product purchased': $localize`product purchased`,
    edit: $localize`edit`,
    chargebacks: $localize`chargebacks`,
    merchants: $localize`merchants`,
    'merchant services': $localize`merchant services`,
    requests: $localize`requests`,
    descriptors: $localize`descriptors`,
    'billing client service': $localize`billing client service`,
    'alerts action queue': $localize`alerts action queue`,
    'client trx data': $localize`client trx data`,
    'merchant data sources': $localize`merchant data sources`,
    'titan runner': `titan runner`,
    'titan action': `titan action`,
    'titan process': `titan process`,
    'titan source': `titan source`,
    'user class': `user class`,
    users: $localize`users`,
    create: $localize`create`,
    'merchant groups': $localize`merchant groups`,
    settings: $localize`settings`,
    queue: $localize`queue`,
    admin: $localize`admin`,
    dashboard: `dashboard`,
    'QuickSight': `QuickSight`,
  },
  countries: [
    {
      Name: 'English',
      languageCd: 'en-us',
      flagImage: 'us-flag',
    },
    {
      Name: 'Portuguese',
      languageCd: 'pt-br',
      flagImage: 'br-flag',
    },
    {
      Name: 'Polish',
      languageCd: 'pl-pl',
      flagImage: 'pl-flag',
    },
    {
      Name: 'Spanish',
      languageCd: 'es-es',
      flagImage: 'es-flag',
    },
  ],
  lightTheme: 'light-theme',
  darkTheme: 'theme-dark',
  passwordStrengthMessages: {
    lowerCase: $localize`At least 1 lower case character`,
    upperCase: $localize`At least 1 upper case character (A-Z)`,
    digits: $localize`At least 1 numerical digit (0-9)`,
    specialChars: $localize`At least 1 special character (examples: !,@,#,$)`,
    minChars: $localize`At least 8 characters`
  },
  headerClientTooltip: $localize`Select Client`,

  midnight: 'arn:aws:quicksight:us-east-1:245276500850:theme/8eb0c70f-50a0-4bf4-992a-bb77315dbe7e',
  classic: 'arn:aws:quicksight:us-east-1:245276500850:theme/94cfc1d7-b6a4-44e1-bfd4-161c6dd2cfe8',

  FD_USER_ROLES: {
    SYSTEM_ADMIN: 'system_admin',
    FD_ADMIN: 'fd_admin',
    FD_USER: 'fd_user',
  }
});
